import {
  actionTypes,
} from 'redux-resource';

export const allListPlugin = resourceType => (state, action) => {
  const includedResources = action?.includedResources || {};
  if (
    [
      actionTypes.READ_RESOURCES_SUCCEEDED,
      actionTypes.CREATE_RESOURCES_SUCCEEDED,
      actionTypes.UPDATE_RESOURCES_SUCCEEDED,
      actionTypes.DELETE_RESOURCES_SUCCEEDED,
    ].includes(action.type)
    && (
      action.resourceType === resourceType
      || includedResources[resourceType]
    )
  ) {
    const resources = (
      action.resourceType === resourceType
        ? (
          action.resources
        )
        : (
          includedResources[resourceType]
        )
    );
    const ids = (
      Array.isArray(resources)
        ? (
          resources.map(
            r => (
              typeof r === 'string'
                ? r
                : r.id
            ),
          )
        )
        : (
          Object.keys(resources)
        )
    );
    const all = (
      action.type === actionTypes.DELETE_RESOURCES_SUCCEEDED
        ? (
          (state.lists?.all || [])
            .filter(id => !ids.includes(id))
        )
        : [
          ...new Set([
            ...(state.lists?.all || []),
            ...ids,
          ]),
        ]
    );
    return {
      ...state,
      lists: {
        ...state.lists,
        all,
      },
    };
  }
  return state;
};
